/**
 * Simple object check.
 * @param item
 */
export function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Simple array check.
 * @param item
 */
export function isArray(item) {
    return item && typeof item === 'object' && Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    let _return;

    if (isObject(target) && isObject(source)) {
        _return = { ...target };
        if (Object.keys(source).length > 0) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    _return[key] = mergeDeep(target[key], source[key]);
                } else {
                    _return[key] = mergeDeep(target[key], source[key]);
                }
            }
        } else {
            Object.assign(_return, {});
        }
    } else if (isArray(target) && isArray(source)) {
        _return = [...target];
        if (source.length > 0) {
            source.forEach((element, index) => {
                if (isArray(element)) {
                    if (!target[index]) target[index] = [];
                    _return[index] = mergeDeep(target[index], source[index]);
                } else if (isObject(element)) {
                    if (!target[index]) Object.assign(target, { [index]: {} });
                    _return[index] = mergeDeep(target[index], source[index]);
                } else {
                    _return[index] = element;
                }
            });
        } else {
            _return = [];
        }
    } else {
        _return = source;
    }

    return mergeDeep(_return, ...sources);


}
